var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceCardTickCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sm-service-card-footer-icon-0",
    d: "M31.6773 17.7993L19.7191 29.6866C19.3165 30.1045 18.6298 30.1045 18.2273 29.6866L13.3019 24.7413C12.8994 24.3234 12.8994 23.6733 13.3019 23.2554C13.7045 22.8375 14.3912 22.8375 14.7937 23.2554L18.985 27.4577L30.2092 16.3134C30.6117 15.8955 31.2984 15.8955 31.701 16.3134C32.1035 16.7313 32.1035 17.3814 31.6773 17.7993Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "sm-service-card-footer-icon-1",
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCardTickCircle);
export default __webpack_public_path__ + "static/media/service-card-tick-circle.4cbf8aeb7fd28716bab881aea059bddf.svg";
export { ForwardRef as ReactComponent };